import { Widget, WidgetType } from '@/app/models/widget.model';
import { HomeService } from '@/app/services/home.service';
import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, Type } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PlaceholderWidgetComponent } from '../widgets/placeholder-widget/placeholder-widget.component';
import { DispatchWidgetComponent } from '../widgets/dispatch-widget/dispatch-widget.component';
import { COMOffersWidgetComponent } from '../widgets/com-offers-widget/com-offers-widget.component';
import { WeatherWidgetComponent } from '../widgets/weather-widget/weather-widget.component';
import { DemandWidgetComponent } from '../widgets/demand-widget/demand-widget.component';
import { ERPWidgetComponent } from '../widgets/erp-widget/erp-widget.component';
import { DispatchForecastWidgetComponent } from '../widgets/dispatch-forecast-widget/dispatch-forecast-widget.component';

@Component({
  selector: 'dr-flex-home-ui-widget-layout',
  imports: [NgComponentOutlet],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './widget-layout.component.html',
  styleUrl: './widget-layout.component.scss',
})
export class WidgetLayoutComponent {
  private readonly homeService = inject(HomeService);
  readonly widgets = toSignal<Widget[] | null>(this.homeService.getWidgets(), { initialValue: null });
  private readonly widgetComponentMap: Record<WidgetType, Type<object>> = {
    WeatherWidget: WeatherWidgetComponent,
    DispatchWidget: DispatchWidgetComponent,
    COMWidget: COMOffersWidgetComponent,
    TrendsWidget: DemandWidgetComponent,
    ERPWidget: ERPWidgetComponent,
    DispatchForecastWidget: DispatchForecastWidgetComponent,
  };

  resolveComponent(type: string): Type<Component> {
    return this.widgetComponentMap[type] ?? PlaceholderWidgetComponent;
  }
}
